import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App.tsx';
import RouteErrorBoundary from './pages/error/RouteErrorBoundary';
import EmbeddedAuthProvider from './contexts/embedded-auth/EmbeddedAuthProvider';
import * as Sentry from '@sentry/react';

import './styles/index.scss';
import { DEV_ENVIRONMENTS } from './config.ts';

if (!DEV_ENVIRONMENTS.includes(import.meta.env.VITE_BUILD)) {
  Sentry.init({
    dsn: 'https://b7fed03a92f1a466d8f5642666d54833@o4505753085739008.ingest.us.sentry.io/4509395061243904',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: import.meta.env.VITE_BUILD,
  });
}

const queryClient = new QueryClient();

const router = createBrowserRouter([
  { path: '*', element: <App />, errorElement: <RouteErrorBoundary /> },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <EmbeddedAuthProvider>
        <RouterProvider router={router} />
      </EmbeddedAuthProvider>
    </QueryClientProvider>
  </StrictMode>
);
